import Request from "./request";

export default class OrderService {
  static async getListAffiliateOrder(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getListAffiliateOrder",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async getAffiliateOrderStatistics(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getAffiliateOrderStatistics",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async getList(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getList",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }
  static async getListById(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getDetail",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }
  static async updateOrder(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/updateOrder",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }
  static async getOrderStatistics(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getOrderStatistics",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async getSummaryListOrderAffiliate(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getSummaryListOrderAffiliate",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async getRevenueByPaymentMethod(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getRevenueByPaymentMethod",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async getRevenueByProductCategory(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getRevenueByProductCategory",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async updateOrder(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/updateOrder",
        data: data,
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async createOrder(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/createOrder",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async getPaymentInfo(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getPaymentInfo",
        data: data,
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async createGiftOrder(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/createGiftOrder",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }

  static async getGiftOrderStatistics(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Order/advanceUser/getGiftOrderStatistics",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve({});
        }
      });
    });
  }
}
